
import React from 'react';
// material
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
// components
import ActionButton from '../../../../components/buttons/ActionButton';
// entities
import { CampaignContact, Campaign } from '../../../../entities/site';

interface CampaignContactTableProps {
  status: string;
  campaign: Campaign;
  campaignContacts: CampaignContact[];
  lastKey: string;
  onLoadMoreClick(): void;
  onReciptClick(contact: CampaignContact): void;
  onLeadClick(contact: CampaignContact): void;
  onClick(contact: CampaignContact): void;
  onView(contact: CampaignContact): void;
}

const CampaignContactTable: React.FC<CampaignContactTableProps> = (props) => {

  const getTotal = () => {
    const c = props.campaign;
    let total = c.totalContacts;
    if (props.status === 'new') {
      total = c.totalContacts - c.totalSent - c.totalDoNotCall - c.totalOptOuts;
    }
    if (props.status === 'sent') {
      total = c.totalSent;
    }
    if (props.status === 'clickThrough') {
      total = c.totalClicks;
    }
    if (props.status === 'optOut') {
      total = c.totalOptOuts;
    }
    return total;
  }

  return (
    <div>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Phone</TableCell>
            <TableCell>Address</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Link</TableCell>
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {props.campaignContacts.map((contact, index) => (
            <TableRow key={`contact-${index}`}>
              <TableCell component="th" scope="row" style={styles.name} onClick={() => props.onView(contact)}>{contact.firstName} {contact.lastName}</TableCell>
              <TableCell>{(contact.email ? contact.email : 'n/a')}</TableCell>
              <TableCell>{contact.phoneNumber}</TableCell>
              <TableCell>
                <div>{contact.address}</div>
                <div>{contact.city}, {contact.state}, {contact.zip}</div>
              </TableCell>
              <TableCell style={styles.status}>{contact.status}</TableCell>
              <TableCell style={styles.status}>{contact.shortLink}</TableCell>
              <TableCell >
                <div style={styles.receipt} onClick={() => props.onReciptClick(contact)}>{contact.status !== 'new' ? 'view receipt' : ''}</div>
              </TableCell>
              <TableCell >
                <div style={styles.receipt} onClick={() => props.onLeadClick(contact)}>Lead</div>
              </TableCell>
              <TableCell/>
              <TableCell style={{ width: '10%' }}>
                <ActionButton name="SEND" size="sm" onClick={() => props.onClick(contact)} fullWidth disabled={contact.status !== 'new' ? true : false} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {
        props.lastKey !== null &&
        <ActionButton name="LOAD MORE" onClick={props.onLoadMoreClick} fullWidth />
      }
      {!props.campaignContacts.length &&
        <div style={styles.importMsg}>No contacts to display</div>
      }
      <div style={styles.footer}>Showing {props.campaignContacts.length} of {getTotal()}</div>
    </div>
  );
};

export default CampaignContactTable;

const styles: any = {
  name: {
    color: '#00ABC7',
    fontSize: '18px',
    textAlign: 'left',
    cursor: 'pointer'
  },
  importMsg: {
    padding: 20,
    fontSize: 14,
    textAlign: 'center'
  },
  stat: {
    fontSize: 28,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  status: {
    color: '#29E2BF'
  },
  receipt: {
    color: '#00ABCA',
    cursor: 'pointer'
  },
  footer: {
    fontSize: 12,
    textAlign: 'right',
    paddingTop: 5,
    color: '#9e9e9e'
  }
}


// WEBPACK FOOTER //
// ./src/pages/admin/campaign/components/CampaignContactTable.tsx